import { FC } from 'react';
import { CartItemType } from '@base/cart/interface';
import { hasWholeSalePrice } from '@pro/product/utils';
import cn from 'classnames';
import { useTrans } from 'base/utils/i18n';

type ICartItemMinOrdersProps = {
    className?: string;
    item: CartItemType;
};

export const CartItemMinOrders: FC<ICartItemMinOrdersProps> = props => {
    const { className, item } = props;
    const { t } = useTrans();

    return hasWholeSalePrice(item) ? (
        <div className={cn(className, 'g-min-qty')}>
            {t('web_wholesale_min_sale_qty', { qty: item.wholesaleMinSaleQuantity })}
        </div>
    ) : null
};
